import { MediaQueries, theme } from '@hhgtech/hhg-components/misc'
import styled from 'styled-components'

import { ArticleCardWrapper } from '../articleCardWrapper'

export const StyledRelatedArticleCarouselWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 24px;
  isolation: isolate;
  margin-block: 16px;

  max-width: 700px;
  /* max-height: 414px; */

  /* White */

  background: #ffffff;
  /* Neutral/Neutral-100 */

  border: 1px solid ${theme?.colors.neutral100};
  border-radius: 8px;
  ${MediaQueries.mbDown} {
    padding: 16px;
    margin-inline: -16px;
    border-radius: 0;
  }
`
export const StyledArticleCardWrapper = styled(ArticleCardWrapper)`
  max-height: 326px;
  &[data-size='sm'][data-direction='horizontal'] {
    padding: 16px 0 0;
  }
  .banner {
    height: auto;
    max-height: unset;
  }
`
